/**
 * Creates a named Error constructor which actually returns
 * a real Error instance (so Chrome/Firefox will format it
 * with their native, red full‑stack style).
 *
 * @param {string} name – the `error.name` to use
 * @returns {Function} – a constructor you can `new`
 */
export default function createErrorType(name) {
  function CustomError(message) {
    // Build a real Error so that [[ErrorData]] is populated
    const err = new Error(message);

    // Assign our custom name
    err.name = name;

    // Point the prototype chain back at CustomError.prototype
    Object.setPrototypeOf(err, CustomError.prototype);

    // Return the real Error object
    return err;
  }

  // Make CustomError.prototype inherit from Error.prototype
  CustomError.prototype = Object.create(Error.prototype);
  CustomError.prototype.constructor = CustomError;

  return CustomError;
}
